/** The part of Stripe.js the SDK uses: a Radar session for the shopper's device. */
export type StripeJs = (publishableKey: string) => {
  createRadarSession(): Promise<{
    radarSession?: { id: string; [key: string]: unknown };
    error?: { message?: string };
  }>;
};

/** Stripe.js from the page, or loaded from Stripe's CDN. */
export function loadStripeJs(): Promise<StripeJs> {
  if (typeof window === 'undefined') return Promise.reject(new Error('Stripe Radar needs a browser'));
  const fromPage = (): StripeJs | undefined => (window as unknown as { Stripe?: StripeJs }).Stripe;
  const loaded = fromPage();
  if (loaded) return Promise.resolve(loaded);

  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/';
    script.async = true;
    script.onload = () => {
      const stripe = fromPage();
      if (stripe) resolve(stripe);
      else reject(new Error('Stripe.js loaded without window.Stripe'));
    };
    script.onerror = () => reject(new Error('Failed to load Stripe.js'));
    document.head.appendChild(script);
  });
}
